<template>
    <div>
        <notifications position="top center" group="info" />

        <div style="font-size: 1.2em">{{message.title}}</div>
        <br />
        
        <div>{{ (message.user_sender.prenom && message.user_sender.nom) ? (message.user_sender.prenom + " " + message.user_sender.nom) : message.user_sender.login }} <i class="fa fa-arrow-right"></i> {{ (message.user_dest.prenom && message.user_dest.nom) ? (message.user_dest.prenom + " " + message.user_dest.nom) : message.user_dest.login }}</div>
        <div><i class="fa fa-calendar"></i> {{ [message.date] | moment('LLL')}}</div>
        <div v-if="mode == 'from'">{{message.seen ? "Lu" : "Pas lu"}}</div>
        <br />

        <div v-html="message.data"></div>

        <b-button variant="danger" @click="deleteMessage">Supprimer</b-button>
    </div>

</template>

<script>
	import store from "../store.js";
    import messages_services from "../services/messages.js";

    import { VueEditor } from "vue2-editor";

	export default {
        name: "message",
        components: {
            VueEditor
        },
        props: {
            message: {
                default: () => {}
            },
            mode: {}
        },
		data: function () {
			return {
			};
		},
		methods: {
            deleteMessage()
            {
                this.$emit("delete", this.message.uid);
            }
		},
		mounted: async function () {
            
            if (store.state.user.rules && !store.state.user.rules.messages) {
                this.$router.push({ name: "profile" });
            }

            //console.log(this.message)
		},
	};
</script>
